import {formatDate} from "@/utils/formatDate";

export function formatTimeRange(time: (number | Date)[]): [string | null, string | null] {
  return time.length === 0 ? [null, null] : [formatDate(time[0], "yyyy-MM-dd"), formatDate(time[1], "yyyy-MM-dd")];
}
